import { render, staticRenderFns } from "./Updates2.vue?vue&type=template&id=a7d8e13c"
import script from "./Updates2.vue?vue&type=script&lang=js"
export * from "./Updates2.vue?vue&type=script&lang=js"
import style0 from "./Updates2.vue?vue&type=style&index=0&id=a7d8e13c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports